import { JSFiddleIcon } from '../../../assets/icons/jsfiddle';
import { createEmbedProvider } from '../factory';

/**
 * JSFiddle URL regex pattern
 * Matches: jsfiddle.net/{user}/{fiddle_id} or jsfiddle.net/{fiddle_id}
 * Group 1: first path segment (user or fiddle_id)
 * Group 2: second path segment (fiddle_id, optional for anonymous fiddles)
 */
export const JSFIDDLE_REGEX = /^https?:\/\/jsfiddle\.net\/([^/]+)(?:\/([^/]+))?\/?/;

/** Check if dark mode is active by reading <html> class */
const isDarkMode = () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark');

export const jsfiddleProvider = createEmbedProvider({
  id: 'jsfiddle',
  label: 'JSFiddle',
  icon: <JSFiddleIcon className="size-5" />,
  regex: JSFIDDLE_REGEX,
  buildEmbedUrl: (_match, cleanedUrl) => {
    // Remove trailing slash and /embedded suffix if present (slash optional)
    const normalizedUrl = cleanedUrl.replace(/(\/embedded)?\/?$/, '');
    const darkSuffix = isDarkMode() ? 'dark/' : '';

    return `${normalizedUrl}/embedded/result,js,css,html/${darkSuffix}`;
  },
  buildTitle: () => 'JSFiddle Embed',
  renderProps: {
    referrerPolicy: 'origin',
  },
});
